import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { 
  Header, 
  HomePage, 
  VideoPlayer, 
  PlaylistPage, 
  FederauxPage,
  FeteDeGymPage,
  DiversPage,
  SearchResults 
} from './components';
import { PWAStatus, InstallPrompt, UpdateNotification } from './PWAComponents';

function App() {
  return (
    <div className="App bg-gray-900 min-h-screen">
      {/* PWA Status and Components */}
      <PWAStatus />
      <UpdateNotification />
      <InstallPrompt />
      
      <Router basename="/medias">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/video/:id" element={<><Header /><VideoPlayer /></>} />
          <Route path="/playlist/:id" element={<><Header /><PlaylistPage /></>} />
          <Route path="/federaux" element={<><Header /><FederauxPage /></>} />
          <Route path="/fete-de-gym" element={<><Header /><FeteDeGymPage /></>} />
          <Route path="/divers" element={<><Header /><DiversPage /></>} />
          <Route path="/search" element={<><Header /><SearchResults /></>} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;